<template>
    <div class="area"></div>
</template>

<script>
export default {
    name: "areaChart",
    props: [ 'config', 'selectRangeDate',"pondsid"],
    data() {
        return {
            myChart:null,
            xData:[],
            yData:[],
            yAxisMin: null, // 用于存储动态的y轴最小值
        }
    },
    methods: {
        setData() {
            this.request.get("/api/Echart/getpage2",{
                params: {
                    pondsid:this.pondsid,
                    param: "Do",
                    number:10
                }
            }).then(res => {
                if(res.code == 200){
                    let data = res.data;
                    this.xData = data.map(item =>{ // 假设 item.time 是 "2024-03-30T10:03:47"  
                        const timeParts = item.time.split(' '); // 将字符串分割为日期和时间两部分  
                        const datePart = timeParts[0]; // 获取日期部分，即 "2024-03-30"  
                        const timePart = timeParts[1]; // 获取时间部分，即 "10:03:47"  
                    
                        // 从日期部分提取月和日  
                        const month = datePart.substring(5, 7); // "03"  
                        const day = datePart.substring(8, 10); // "30"  
                    
                        // 从时间部分提取时和分  
                        const hour = timePart.substring(0, 2); // "10"  
                        const minute = timePart.substring(3, 5); // "03"  
                    
                        // 拼接成 "月 日 时 分" 的格式  
                        return `${month}-${day} ${hour}:${minute}`; });
                    this.yData = data.map(item => item.do)    
                    this.updateDynamicYAxis(); // 计算并更新y轴最小值
                }
                this.setChart()
            })   
        },
        updateDynamicYAxis() {
            if (this.yData.length > 0) {
                const minVal = Math.min(...this.yData);
                this.yAxisMin = minVal - 0.1; // 减去0.1以确保所有数据都能清晰显示
            }
        },
        setSeriesData() {
            let arr = [];
            this.config.data.forEach(item=> {
                let obj = {
                    name: item.name,
                    type: 'line',
                    smooth: true,
                    symbol: "none",
                    areaStyle: {
                        opacity: 1,
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: item.color[0] // 0% 处的颜色
                            },
                                {
                                    offset: 0.4, color: item.color[0] // 40% 处的颜色
                                }, {
                                    offset: 1, color: item.color[1] // 100% 处的颜色
                                }],
                            global: false // 缺省为 false
                        }
                        // color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        //     offset: 0, color: item.color[0] // 0% 处的颜色
                        // },
                        //     {
                        //         offset: 0.4, color: item.color[0] // 0% 处的颜色
                        //     }, {
                        //         offset: 1, color: item.color[1] // 100% 处的颜色
                        //     }]), //背景渐变色
                        // origin: 'start'
                    },
                    lineStyle: {
                        width: 0,
                    },
                    itemStyle: {
                        color: item.color[0]
                    },
                    data: this.yData,
                    
                    // data: item.data
                }
                arr.push(obj)
            })
            return arr;
        },
        setChart() {
            let option = {
                title: {
                    show: !!this.config.title,
                    text: this.config.title,
                    textStyle: {
                        color:'#fff',
                        fontSize: 12,
                        fontWeight: 'normal'
                    },
                    top: '12%',
                    left: '38%'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'none'        // 默认为直线，可选为：'line' | 'shadow'
                    },
                    backgroundColor: '#11367a',
                    textStyle: {
                        color: '#fff',
                        fontSize: 10,
                    },

                    formatter: function (params) {
                        let str = params[0].name;
                        params.forEach(item=> {
                            str += `<br> ${item.seriesName}: ${item.value}`
                        })
                        return str
                    }
                },
                legend:
                    {
                        top: this.config.title?'23%': '11%',
                        left: 'center',
                        itemWidth: 7,
                        itemHeight:7,
                        textStyle: {
                            color: '#fff',
                            fontSize: 12
                        },
                    },
                grid:
                    {
                        top: this.config.title?'40%': '14%',
                        left: '5%',
                        right: '5%',
                        bottom: '5%',
                        containLabel: true
                    },
                xAxis:
                    {
                        type: 'category',
                        boundaryGap: false,
                        axisLabel: {
                            interval: 0,
                            color: '#fff',
                            fontSize: 9,
                            align: 'center'
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#1a3c58',
                                width: 2,
                            }
                        },
                        axisTick: {show: false},
                        data: this.xData
                    },
                yAxis: [
                    {
                        type: 'value',
                        min: this.yAxisMin, // 使用动态最小值
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#fff'
                            }
                        },
                        axisLabel: {
                            color: this.config.color,
                            fontSize: 9,
                            showMaxLabel: false,
                            formatter: function(value) {
                return value.toFixed(2); // 保留两位小数
            }
                        },
                        axisTick: {
                            length: 3
                        },
                        name: this.config.name[0],
                        nameGap: -5,
                        nameTextStyle: {
                            color: this.config.color,
                            fontSize: 9,
                            align: 'right'
                        },
                        splitLine: {show: false}

                    },
                    // {
                    //     type: 'value',
                    //     min: 0,
                    //     max: 300,
                    //     axisLine: {
                    //         show: true,
                    //         lineStyle: {
                    //             color: '#1a3c58'
                    //         }
                    //     },
                    //     axisTick: {
                    //         length: 3
                    //     },
                    //     axisLabel: {
                    //         color: this.config.color,
                    //         fontSize: 9,
                    //         showMaxLabel: false,
                    //     },
                    //     name: this.config.name[1],
                    //     nameTextStyle: {
                    //         color: this.config.color,
                    //         fontSize: 9,
                    //         align: 'left'
                    //     },
                    //     nameGap: -5,
                    //     splitLine: {show: false}
                    // },
                ],
                series: this.setSeriesData()
            };
            if (this.selectRangeDate.length > 7) {
                option.xAxis.axisLabel.interval = 3;
                option.xAxis.axisLabel.showMaxLabel = false;
                option.xAxis.axisLabel.align = 'left';
            }
            if (!this.myChart) this.myChart = this.$echarts(this.$el);
            this.myChart.clear();
            this.myChart.resize()
            this.myChart.setOption(option);
            
        }
    },
    mounted() {
        this.setData();
    },
    watch: {
        pondsid() {
            this.setData();
        }}
}
</script>

<style lang="less" scoped>
.area {
    height: 100%;
}
</style>